import type { ReactNode, JSX } from 'react';
import { createContext, useContext } from 'react';

interface ContextValue {
  basePath: string;
}

export const AccountUIApiContext = createContext<ContextValue>({ basePath: '' });

interface Props {
  basePath: string;
  children: ReactNode;
}

/**
 * Add this provider to _app to enable the use of all of the hooks.
 */
export function AccountUIApiProvider(props: Props): JSX.Element {
  const { basePath, children } = props;
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <AccountUIApiContext.Provider value={{ basePath }}>{children}</AccountUIApiContext.Provider>;
}

export function useAccountUIApiBasePath(): string {
  const { basePath } = useContext(AccountUIApiContext);
  return basePath;
}
